import styled from 'styled-components';

export const TextArea = styled.textarea`
	${({ theme }) => theme.typography.label.medium}
	resize: vertical;
	box-sizing: border-box;
	border-radius: 12px;
	padding: 12px;
	display: flex;
	border: 1px solid #ced4da;
	margin-top: 16px;
	color: ${({ theme }) => theme.colors.neutral.black};
	width: 100%;

	&::placeholder {
		color: #999;
	}

	&:focus-visible {
		outline: solid 1px ${({ theme }) => theme.colors.primary.medium};
	}
`;

export const Label = styled.label`
	${({ theme }) => theme.typography.headlines.h6}
	width: 100%;
	display: inline-block;
	margin-bottom: 8px;
`;
